import { render, staticRenderFns } from "./HeaderContext.vue?vue&type=template&id=8dca2aac&"
import script from "./HeaderContext.vue?vue&type=script&lang=js&"
export * from "./HeaderContext.vue?vue&type=script&lang=js&"
import style0 from "./HeaderContext.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports